<div class="flex flex-column p-box-36 gap-6">
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-row gap-4">
      <div class="icon-container-outlined"><mat-icon class="material-symbols-outlined">add_location_alt</mat-icon></div>
      <div class="flex flex-column gap-2">
        <div class="mat-headline-large">Location permission request</div>
        <div class="mat-body-medium">
          A location permission request is required because we not allowed to track their location without explicit consent
        </div>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="flex flex-row gap-2 items-center">
    <div class="steps-indicator mat-body-small">1</div>
    <div>Please provide a question that will be displayed to users before requesting their location access.</div>
  </div>
  <form [formGroup]="geolocationForm" class="geolocation-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Location Request Question</mat-label>
      <textarea matInput [formControl]="geolocationForm.controls.question"
        placeholder="e.g., 'Would you like to share your location to find nearby services?'" rows="4"
        maxlength="500">
      </textarea>
      <mat-hint align="start">Be clear, give the benefit, keep it short, and sound friendly</mat-hint>
      <mat-hint align="end">
        {{ geolocationForm.controls.question.value?.length || 0 }}/500
      </mat-hint>

      <!-- Error messages -->
      @if (geolocationForm.controls.question.hasError('required') && geolocationForm.controls.question.touched) {
        <mat-error
          >
          A question is required
        </mat-error>
      }
      @if (geolocationForm.controls.question.hasError('minlength') && geolocationForm.controls.question.touched) {
        <mat-error
          >
          Question must be at least 10 characters long
        </mat-error>
      }
      @if (geolocationForm.controls.question.hasError('maxlength') && geolocationForm.controls.question.touched) {
        <mat-error
          >
          Question cannot exceed 500 characters
        </mat-error>
      }
    </mat-form-field>
  </form>
  <mat-divider></mat-divider>
  <div class="flex flex-column hint-container grow">
    <div class="flex flex-row items-center gap-2">
      <mat-icon class="material-symbols-outlined">lightbulb</mat-icon>
      <div class="mat-title-medium font-weight-bold">Best Practice</div>
    </div>
    <ul class="mat-body-medium">
      <li>Be clear about why you need location access</li>
      <li>Explain the benefit to the user (e.g., "find nearby stores")</li>
      <li>Keep the question concise but informative</li>
      <li>Use friendly, conversational language</li>
      <li>Consider mentioning that location data is kept private</li>
    </ul>
  </div>
  <mat-divider></mat-divider>
  <div class="flex flex-row gap-3">
    <button matButton="outlined" (click)="onClose()">Cancel</button>
    <button matButton="filled" (click)="onUpdate()" [disabled]="geolocationForm.invalid">
      Apply settings
    </button>
  </div>
</div>
